<ng-container>
	<div
		[matTooltipTemplate]="statsTemplate"
		[matTooltipTemplateContext]="{ stats: s }"
		*ngIf="this.stats$ | async as s"
		matTooltip
	>
		<div class="mat-circle-card">
			<mat-progress-spinner
				[color]="s.exceeded ? 'warn' : 'accent'"
				[diameter]="20"
				[value]="s.recordedPercentage"
				class="with-back-spinner"
				strokeWidth="3"
			></mat-progress-spinner>
		</div>
	</div>
</ng-container>
<ng-template
	#statsTemplate
	let-stats="stats"
>
	<div class="flex flex-row items-center space-x-1">
		<ng-container *ngIf="inReports$ | async">
			<span> {{ 'overall-status.budget-total' | translate }}:</span>
		</ng-container>
		<span>{{ stats.recorded | parseMsAsDuration: false }}</span>
		<span>{{ 'task.estimation-header-of' | translate }}</span>
		<span>{{ stats.estimation | parseMsAsDuration: false }}</span>
		@if(stats.estimation > 0) {
		<span>({{ stats.recordedPercentageAsString }}%)</span>
		} @else {
		<span>({{ 'project.budget.withoutBudget' | translate }})</span>
		}
	</div>
</ng-template>
